/* eslint-disable camelcase */

export enum TYPE_OPTIONS {
	COMPLETION = 'Completion',
	CHAT_COMPLETION = 'Chat completion',
}

export enum INDUSTRY_OPTIONS {
	TMT = 'Technology, Media, Telecom (TMT)',
	PAYER_PROVIDER = 'Payer/ Provider',
	PLS = 'Pharmaceutical and Life Sciences (PLS)',
	INS = 'Insurance (INS)',
	EUR = 'Energy, Utilities and Resources (EUR)',
	AWM = 'Asset and Wealth Management (AWM)',
	PE = 'Private Equity (PE)',
	CM = 'Consumer Markets (CM)',
}

export enum CATEGORY_OPTIONS {
	CREATE = 'Create',
	IMPROVE = 'Improve',
	SUMMARIZE = 'Summarize',
}

export enum TYPE_DISPLAY_MAPPING {
	COMPLETION_DISPLAY = 'Completion',
	CHAT_COMPLETION_DISPLAY = 'ChatCompletion',
}
export const PROMPT_LIB =
	'Toggle prompts to select from when generating across Risk Link. Only one prompt may be selected for an AI model at a time';
export const ADD_NEW_PROMPT_BTN = 'Create new';

export const PROMPT_TYPE_TITLE_SUB_HEADER = 'Only one selection is allowed.';
export const PROMPT_TYPE_TITLE = 'Prompt type';
export const PROMPT_OUTPUT_TITLE = 'Select a prompt output';
export const PROMPT_OUTPUT_TITLE_SUB_HEADER =
	'If no existing options suits you, create a new custom prompt. Only one selection is allowed.';
export const PROMPT_TOOLKIT_TITLE =
	'This toolkit can be accessed in the following areas';

export const PROMPT_TITLE_LABEL = 'Create new prompt';
export const PROMPT_SUB_TITLE_LABEL =
	'Start from an existing model template or choose custom model.';
export const PROMPT_TITLE_MESSAGE_LABEL =
	'Consider adding client name into title';

export const PROMPT_TITLE_UNIQUE_ERROR =
	'Please give the duplicate a unique title.';

export const PROMPT_DEFAULT_MESSAGES = {
	DEFAULT_INFO:
		'View and set as the default prompt model to be executed for the corresponding location.',
	DEFAULT_WARNING: 'Would you like to replace existing default?',
	NO_LOCATIONS_MSG: 'No options available',
};

export enum MESSAGE_OPTIONS {
	SYSTEM = 'system',
	USER = 'user',
	ASSISTANT = 'assistant',
}

export enum TOAST_MESSAGE {
	PUBLISH_SUCCESS = 'Your prompt has been successfully published and is now live.',
	SAVE_DRAFT_SUCCESS = 'Your prompt draft saved successffully',
	PUBLISH_FAILURE = 'Prompt publish failed',
	SAVE_DRAFT_FAILURE = 'Could not save your draft. Try again later',
	DUPLICATE_PROMPTS_FAILURE = 'Duplicate prompts not allowed',
}

export enum BUTTON_ACTIONS {
	PUBLISH = 'Publish',
	SAVE_DRAFT = 'Save draft',
	GO_BACK = 'Go back',
}

export enum PROMPT_ERROR_MESSAGE {
	INVALID_KEY = 'Entered key is invalid',
}

export const initialPrompt = {
	description: '',
	key: '',
	messages: [],
	aiModelKey: '',
	is_active: false,
	is_draft: true,
	tags: [],
	parameters: {
		frequency_penalty: 0,
		max_tokens: undefined,
		presence_penalty: 0,
		stop_sequence: [],
		temperature: 0,
		top_p: 0,
		industry: '',
		category: '',
	},
	prompt: '',
	type: TYPE_OPTIONS.CHAT_COMPLETION,
};

export const rangeSliderObject = [
	{ title: 'Top Probabilities', id: 'top_p' },
	{ title: 'Frequency Penalty', id: 'frequency_penalty' },
	{ title: 'Presence Penalty', id: 'presence_penalty' },
];

export enum PANE_TAB_VALUES {
	TITLE = 'Title and description',
	PROMPT = 'Prompt settings',
	CONFIGURE = 'Configure settings',
	TEST = 'Test',
}

export enum SYSTEM_TAGS {
	DEFAULT = 'Default',
	DRAFT = 'Draft',
}

export enum CREATE_NEW_TYPES {
	PROMPT = 'Prompt',
	AI_RECIPE = 'AI recipe/toolkit',
}
